import React, { useEffect, useState } from 'react';
import styles from '../styles/ApiDocs.module.css';
import axiosInstance from '../services/axiosInstance';

const ApiDocs = () => {
    const [specUrl, setSpecUrl] = useState('');

    useEffect(() => {
        const apiBaseUrl = process.env.NODE_ENV === 'production' 
            ? 'https://stockkhata-webapp.onrender.com/api-docs/swagger.json' 
            : 'http://localhost:5000/api-docs/swagger.json';

        setSpecUrl(apiBaseUrl);
    }, []);

    useEffect(() => {
        if (!specUrl) return;

        const redocScript = document.createElement('script');
        redocScript.src = 'https://cdn.jsdelivr.net/npm/redoc@next/bundles/redoc.standalone.js';
        redocScript.async = true;
        redocScript.onload = () => {
            if (window.Redoc) {
                window.Redoc.init(specUrl, {}, document.getElementById('redoc-container'));
            }
        };
        document.body.appendChild(redocScript);

        return () => {
            document.body.removeChild(redocScript);
        };
    }, [specUrl]);

    return (
        <div className={styles.apiDocsContainer}>
            <h1 className={styles.apiDocsTitle}>API Documentation</h1>
            <div id="redoc-container" className={styles.apiDocsRedoc}></div>
        </div>
    );
};

export default ApiDocs;
